const getCookie = name => {
  if (typeof document === 'undefined') {
    return null;
  }
  const cookie = document.cookie.match("(^|;) ?".concat(name, "=([^;]*)(;|$)"));
  return cookie ? cookie[2] : null;
};
export default getCookie;